import { render, staticRenderFns } from "./Coupon.vue?vue&type=template&id=40d45d71&scoped=true&"
import script from "./Coupon.vue?vue&type=script&lang=js&"
export * from "./Coupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d45d71",
  null
  
)

component.options.__file = "Coupon.vue"
export default component.exports